import { ParsedUrlQuery, stringify } from "querystring";

import {
  DEFAULT_PAGE,
  DEFAULT_SEARCH_LANGUAGE,
  DEFAULT_SEARCH_SORT_BY,
  LANGUAGE_FILTER_OPTIONS,
  SORT_BY_FILTER_OPTIONS,
} from "@/search/NewSearchPageMVP/NewSearchPageMVP.constants";
import { IAgathaSchema } from "@/search/NewSearchPageMVP/types/IAgathaSchema";
import { AgathaSchemaParamsEnum } from "@/search/NewSearchPageMVP/types/IParametersSchema";

export const getValidQueryParams = (agathaSchema: IAgathaSchema) => {
  const filterParameters = Object.fromEntries(
    Object.entries(agathaSchema.parameters).filter(
      ([, paramValue]) => paramValue.category === "filter",
    ),
  );
  const sortByParameter =
    agathaSchema.parameters[AgathaSchemaParamsEnum.sort_by];
  const needleParameter =
    agathaSchema.parameters[AgathaSchemaParamsEnum.needle];
  const contentTypesParameter =
    agathaSchema.parameters[AgathaSchemaParamsEnum.content_types];
  const filterControlsParameter =
    agathaSchema.parameters[AgathaSchemaParamsEnum.filter_controls];
  const gradeLevelParameter =
    agathaSchema.parameters[AgathaSchemaParamsEnum.grade_level];

  return {
    ...filterParameters,
    [AgathaSchemaParamsEnum.needle]: needleParameter,
    [AgathaSchemaParamsEnum.sort_by]: sortByParameter,
    [AgathaSchemaParamsEnum.grade_level]: gradeLevelParameter,
    [AgathaSchemaParamsEnum.content_types]: contentTypesParameter,
    [AgathaSchemaParamsEnum.filter_controls]: filterControlsParameter,
  };
};

export const initializeSearchParams = (query: ParsedUrlQuery) => {
  const searchParams = new URLSearchParams(stringify(query));
  const validSearchParams = Object.keys(AgathaSchemaParamsEnum);
  const allSearchParams = [...searchParams.entries()];

  // Only load valid search parameters
  allSearchParams.forEach(([paramName]) => {
    if (!validSearchParams.includes(paramName)) {
      searchParams.delete(paramName);
    }
  });

  // Set default filters
  const isSortByParamValueValid = SORT_BY_FILTER_OPTIONS.map(
    ({ value }) => value,
  ).includes(searchParams.get(AgathaSchemaParamsEnum.sort_by) || "");
  if (!isSortByParamValueValid) {
    searchParams.set(AgathaSchemaParamsEnum.sort_by, DEFAULT_SEARCH_SORT_BY);
  }

  const isLanguageParamValueValid = LANGUAGE_FILTER_OPTIONS.map(
    ({ value }) => value,
  ).includes(searchParams.get(AgathaSchemaParamsEnum.language) || "");
  if (!isLanguageParamValueValid) {
    searchParams.set(AgathaSchemaParamsEnum.language, DEFAULT_SEARCH_LANGUAGE);
  }

  const hasPageParam = searchParams.get(AgathaSchemaParamsEnum.page);
  if (!hasPageParam) {
    searchParams.set(AgathaSchemaParamsEnum.page, DEFAULT_PAGE);
  }

  return searchParams;
};
